import { useQuery } from '@tanstack/react-query';
import isNil from 'lodash-es/isNil';
import { useSelector } from 'react-redux';

import { permissionsEndpoints as endpoints } from '@/api/endpoints';
import { callGet } from '@/api/fetcher';
import { selectPermissions } from '@/redux/permissions/selectors';
import { Permissions } from '@/shared/types/permissions';

import { useAccount } from './useAccount';

export const API = {
  getPermissions: async (): Promise<Permissions> => callGet(endpoints.permissions),
};

export const usePermissions = () => {
  const { account } = useAccount();
  const storePermissions = useSelector(selectPermissions);

  const { data: permissions, status: listStatus } = useQuery<Permissions>({
    queryKey: [endpoints.permissions, account?.account_id],
    queryFn: API.getPermissions,
    enabled: !!account?.account_id,
  });

  return {
    // Pages check access against the store, which the account layout fills one render after the
    // query resolves, so report pending until it holds the permissions.
    listStatus: listStatus === 'success' && isNil(storePermissions) ? 'pending' : listStatus,
    isLoading: listStatus === 'pending' && !isNil(storePermissions),
    permissions: permissions?.permissions,
  };
};
